import { Tab } from '@mui/material';
import './tab.scss';

/** @param {import('@mui/material').TabProps} param0 */
const CoreTab = ({ className, ...props }) => (
    <Tab
        className={`${className || ''} core--tab`}
        {...props}
    />
);

export default CoreTab;
